
import {
  CREATE_USER_BEGIN,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  FETCH_USERS_BEGIN,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FILTER_USERS_BEGIN,
  FILTER_USERS_SUCCESS,
  FILTER_USERS_FAIL,
  SELECT_USER,
  DESELECT_USER,
  DELETE_USER_BEGIN,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  RESET_PASSWORD_BEGIN,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  CLEAR_PW_RESULT,
  CLEAR_LOGIN_RESULT,
  VALIDATE_PW_TOKEN_BEGIN,
  VALIDATE_PW_TOKEN_SUCCESS,
  VALIDATE_PW_TOKEN_FAIL,
  SEND_PASS_EMAIL_BEGIN,
  SEND_PASS_EMAIL_FAIL,
  SEND_PASS_EMAIL_SUCCESS,
  FETCH_ROLES_BEGIN,
  FETCH_ROLES_FAILURE,
  FETCH_ROLES_SUCCESS,
  UPDATE_USER_BEGIN,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  ADD_USER_ROLE,
  REMOVE_USER_ROLE,
  CLEAR_ROLES,
  UPLOAD_USERS_BEGIN,
  UPLOAD_USERS_SUCCESS,
  UPLOAD_USERS_FAIL,
  GET_LOGGED_IN_USER_BEGIN,
  GET_LOGGED_IN_USER_SUCCESS,
  GET_LOGGED_IN_USER_FAIL,
  NAVIGATE_PAGE,
  GET_CONFIG_BEGIN,
  GET_CONFIG_SUCCESS,
  GET_CONFIG_FAIL,
  CREATE_IMPS_BEGIN,
  CREATE_IMPS_SUCCESS,
  CREATE_IMPS_FAIL
} from "../action/userActions";


const initialState = {
  config: {},
  loggedInUser: {},
  createResult: {},
  createdImpersonations: [],
  impersonationAlreadyRunning: false,
  loading: false,
  error: null,
  users: [],
  usersLoading: false,
  filteredUsers: [],
  filterLoading: false,
  selectedUser: null,
  resetPasswordResult: null,
  resetPwError: null,
  roles: [],
  rolesLoading: false,
  updateLoading: false,
  updateResult: null,
  uploadLoading: false,
  uploadResult: null,
  userInfo: {},
  page: 1
};

export default function userReducer(
  state = initialState,
  action
) {
  console.log(action.type)



  switch (action.type) {

    case CREATE_IMPS_BEGIN:
      return { ...state, loading: true, createdImpersonations: [], error: null, impersonationAlreadyRunning: false }
    case CREATE_IMPS_SUCCESS:
      return { ...state, loading: false, createdImpersonations: action.payload.impersonations.impersonations, impersonationAlreadyRunning: action.payload.impersonations.alreadyRunning }
    case CREATE_IMPS_FAIL:
      return { ...state, loading: false, error: action.payload.error }

    case GET_CONFIG_BEGIN:
      return { ...state, config: {} }
    case GET_CONFIG_SUCCESS:
      return { ...state, config: action.payload.config }
    case GET_CONFIG_FAIL:
      return { ...state, config: {}, error: action.payload.error }

    case NAVIGATE_PAGE:
      return { ...state, page: action.payload.page }
    case GET_LOGGED_IN_USER_BEGIN:
      return {
        ...state,
        userInfo: {}
      }
    case GET_LOGGED_IN_USER_SUCCESS:
      return {
        ...state,
        userInfo: action.payload.result
      }

    case GET_LOGGED_IN_USER_FAIL:
      return {
        ...state,
        error: action.payload.error
      }

    case UPLOAD_USERS_BEGIN:
      return {
        ...state,
        uploadLoading: true,
        uploadResult: null
      }

    case UPLOAD_USERS_SUCCESS:
      return {
        ...state,
        uploadLoading: false,
        uploadResult: action.payload.result
      }

    case UPLOAD_USERS_FAIL:
      return {
        ...state,
        uploadLoading: false,
        uploadResult: action.payload.error,
        error: action.payload.error
      }

    case CLEAR_ROLES:

      if (action.payload.leaveOne) {
        if (state.roles.length == 0) {
          let rr = [...state.roles]
          rr.push({
            userId: null,
            securityContextValue: null,
            groupId: null,
            groupName: null,
            type: action.payload.type
          })

          return {
            ...state,
            roles: rr
          }

        } else {
          return {
            ...state,
            roles: [state.roles[0]]
          }
        }

      }
      else {
        return {
          ...state,
          roles: []
        }
      }


    case REMOVE_USER_ROLE:
      let r = [...state.roles]
      r.splice(action.payload.role, 1)

      if (action.payload.role.userId)
        r.push({ userId: action.payload.role.userId })

      return { ...state, roles: r }

    case ADD_USER_ROLE:
      let rr = [...state.roles]
      let oldUserIds = rr.filter(ro => {
        return ro.userId != null && !ro.securityContextValue
      })

      rr.push({
        userId: oldUserIds.length > 0 ? oldUserIds[0] : null,
        securityContextValue: null,
        groupId: null,
        groupName: null,
        type: action.payload.type
      })

      return { ...state, roles: rr }

    case UPDATE_USER_BEGIN:
      return {
        ...state,
        loading: true,
        createResult: {},
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        createResult: action.payload.result,
        loading: false
      }

    case UPDATE_USER_FAILURE:
      return {
        ...state,
        createResult: action.payload.result,
        loading: false
      }

    case FETCH_ROLES_BEGIN:
      return {
        ...state,
        rolesLoading: true,
        roles: []
      }
    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        rolesLoading: false,
        roles: action.payload.roles
      }

    case FETCH_ROLES_FAILURE:
      return {
        ...state,
        rolesLoading: false,
        error: action.payload.error
      }

    case SEND_PASS_EMAIL_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        loggedInUser: {}
      }
    case SEND_PASS_EMAIL_SUCCESS:
      let user = {}
      console.log('email senet', action.payload)
      if (action.payload.result.emailSent) {
        user = { emailSent: true }
      }
      else {
        user = { emailSent: false, noUser: true }
      }
      return {
        ...state,
        loggedInUser: user,
        loading: false,

      }
    case VALIDATE_PW_TOKEN_FAIL:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      }

    case VALIDATE_PW_TOKEN_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        loggedInUser: {}
      }

    case VALIDATE_PW_TOKEN_SUCCESS:
      user = {}
      console.log('valid', action.payload.result.valid)
      if (action.payload.result.valid) {
        user = { success: true, userName: action.payload.result.userName }
      }
      else {
        user = { fail: true }
      }
      return {
        ...state,
        loggedInUser: user,
        loading: false,

      }
    case VALIDATE_PW_TOKEN_FAIL:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      }

    case CLEAR_LOGIN_RESULT:

      return {
        ...state,
        loggedInUser: {},
        error: null
      }

    case CLEAR_PW_RESULT:
      return {
        ...state,
        resetPwError: null,
        resetPasswordResult: null
      }

    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        loggedInUser: {}
      }



    case LOGIN_SUCCESS:
      user = {}
      if (action.payload.result.auth) {
        user = { success: true, userName: action.payload.result.userName }
      }
      else {
        user = { fail: true, userName: action.payload.result.userName }
      }
      console.log('login result', user)
      return {
        ...state,
        loading: false,
        loggedInUser: user
      }

    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      }

    case RESET_PASSWORD_BEGIN:

      return {
        ...state,
        loading: true,
        error: null
      }

    case RESET_PASSWORD_SUCCESS:

      return {
        ...state,
        loading: false,
        resetPasswordResult: action.payload.result
      }

    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      }

    case SELECT_USER:

      return {
        ...state, selectedUser: action.payload.user
      }

    case DESELECT_USER:

      return {
        ...state, selectedUser: null, createResult: {}
      }

    case FETCH_USERS_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        usersLoading: true,
        error: null
      };

    case FETCH_USERS_SUCCESS:
      // All done: set loading "false".
      // Also, replace the groups with the ones from the server

      let fs = [...state.filteredUsers]
      let newFs = []
      if (fs.length > 0) {
        fs.forEach(f => {
          let uUser = action.payload.users.find(u => u.email == f.email)
          if (uUser) {
            f = { ...uUser }
            newFs.push(f)
          }
        })
      }
      return {
        ...state,
        usersLoading: false,
        users: action.payload.users,
        filteredUsers: newFs
      };



    case FETCH_USERS_FAILURE:
      // The request failed, but it did stop, so set loading to "false".
      // Save the error, and we can display it somewhere
      // Since it failed, we don't have groups to display anymore, so set it empty.
      // This is up to you and your app though: maybe you want to keep the groups
      // around! Do whatever seems right.


      return {
        ...state,
        usersLoading: false,
        error: action.payload.error,
        users: []
      };

    case FILTER_USERS_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        filterLoading: true,
        error: null
      };

    case FILTER_USERS_SUCCESS:
      // All done: set loading "false".
      // Also, replace the groups with the ones from the server

      return {
        ...state,
        filterLoading: false,
        filteredUsers: action.payload.filteredUsers
      };

    case FILTER_USERS_FAIL:
      // The request failed, but it did stop, so set loading to "false".
      // Save the error, and we can display it somewhere
      // Since it failed, we don't have groups to display anymore, so set it empty.
      // This is up to you and your app though: maybe you want to keep the groups
      // around! Do whatever seems right.
      console.log(action.payload.error)
      return {
        ...state,
        filterLoading: false,
        error: action.payload.error,
        filteredUsers: []
      };
    /*       case FILTER_USERS :
    
         var context =  action.payload.context['Public Id of Manufacturer'] ?
         action.payload.context['Public Id of Manufacturer']
        : action.payload.context['Public Id of Distributor']
        
          var fUsers = state.users.filter(user =>{
             return user.securityContextValue == context
          })
    
          return {
            ...state,
            filteredUsers : fUsers
          }
     */
    case CREATE_USER_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null
      };

    case CREATE_USER_SUCCESS:
      // All done: set loading "false".
      // Also, replace the groups with the ones from the server

      var users = [...state.users]
      users.push(action.payload.result.user)
      var fUsers = [...state.filteredUsers]
      fUsers.push(action.payload.result.user)



      return {
        ...state,
        loading: false,
        createResult: action.payload.result,
        users: users,
        filteredUsers: fUsers
      };

    case CREATE_USER_FAILURE:
      // The request failed, but it did stop, so set loading to "false".
      // Save the error, and we can display it somewhere
      // Since it failed, we don't have groups to display anymore, so set it empty.
      // This is up to you and your app though: maybe you want to keep the groups
      // around! Do whatever seems right.

      console.log('erroer', action)
      return {
        ...state,
        loading: false,
        error: action.payload.error.message,
        createResult: action.payload.result,

      }

    case DELETE_USER_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null
      };

    case DELETE_USER_SUCCESS:
      // All done: set loading "false".
      // Also, replace the groups with the ones from the server
      var newUsers = state.users.filter(user => {
        return user['login'] != state.selectedUser['login']
      })
      var newFiltered = state.filteredUsers.filter(user => {
        return user['login'] != state.selectedUser['login']
      })
      return {
        ...state,
        loading: false,
        createResult: action.payload.result,
        users: newUsers,
        filteredUsers: newFiltered
      };

    case DELETE_USER_FAIL:
      // The request failed, but it did stop, so set loading to "false".
      // Save the error, and we can display it somewhere
      // Since it failed, we don't have groups to display anymore, so set it empty.
      // This is up to you and your app though: maybe you want to keep the groups
      // around! Do whatever seems right.
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        createResult: action.payload.result,
      }

    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
}
